import { createSlice } from '@reduxjs/toolkit';
import objectsAreEqual from '../../utils/objects-are-equal';
import arraysAreEqual from '../../utils/arrays-are-equal';

export const homecardOrder = ['welcome', 'pwa', 'favorites'];

const defaultHomecards = homecardOrder.map((name) => ({
  name,
  visible: true,
}));

export const appSettingsSlice = createSlice({
  name: 'appSettings',
  initialState: {
    language: 'de',
    darkmode: false,
    sectionnav: {},
    favoriteorders: [],
    homecards: defaultHomecards,
    selections: [],
    isLoaded: false,
  },
  reducers: {
    updateAppSettings: (state, action) => {
      state.isLoaded = true;

      if (action.payload === null) {
        return state;
      }
      if (
        action.payload.language != null &&
        state.language !== action.payload.language
      ) {
        state.language = action.payload.language;
      }
      if (
        action.payload.darkmode != null &&
        state.darkmode !== action.payload.darkmode
      ) {
        state.darkmode = action.payload.darkmode;
      }
      if (
        action.payload.sectionnav != null &&
        !objectsAreEqual(state.sectionnav, action.payload.sectionnav)
      ) {
        state.sectionnav = action.payload.sectionnav;
      }
      if (
        action.payload.favoriteorders != null &&
        !arraysAreEqual(state.favoriteorders, action.payload.favoriteorders)
      ) {
        state.favoriteorders = action.payload.favoriteorders;
      }
      if (
        action.payload.homecards != null &&
        !arraysAreEqual(state.homecards, action.payload.homecards)
      ) {
        state.homecards = action.payload.homecards;
      }
      if (
        action.payload.selections != null &&
        !arraysAreEqual(state.selections, action.payload.selections)
      ) {
        state.selections = action.payload.selections;
      }
    },
    updateSectionNavSettings: (state, action) => {
      const { sectionnav } = state;
      sectionnav[action.payload.navId] = action.payload.isExpanded;
      state.sectionnav = sectionnav;
    },
    setSelection: (state, action) => {
      const { selections } = state;
      const selectionIndex = selections.findIndex(
        (value) =>
          value.url === action.payload.url && value.type === action.payload.type
      );
      if (selectionIndex < 0) {
        selections.push(action.payload);
      } else {
        selections[selectionIndex] = action.payload;
      }

      state.selections = selections;
    },
    resetHomecards: (state) => {
      state.homecards = defaultHomecards;
      state.isLoaded = false;
      state.favoriteorders = [];
    },
  },
});

export const {
  updateAppSettings,
  updateSectionNavSettings,
  setSelection,
  resetHomecards,
} = appSettingsSlice.actions;

export default appSettingsSlice.reducer;
